const ComingSoon = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-[20px] font-semibold">Coming Soon...</p>
    </div>
  );
};

export default ComingSoon;
